import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "menu-tag",
  "use": "menu-tag-usage",
  "viewBox": "0 0 20 20.01",
  "content": "<symbol viewBox=\"0 0 20 20.01\" id=\"menu-tag\"><title>menu-tag</title><path d=\"M.53,10,10.12.33A2.06,2.06,0,0,1,10.61,0l.22,0h7.61A1.84,1.84,0,0,1,19,.09a1.15,1.15,0,0,1,.52.34,1,1,0,0,1,.3.52c0,.18.07.37.1.56a0,0,0,0,0,0,0Q20,3.45,20,5q0,.67,0,1.33t0,1.17V8.86a1,1,0,0,1-.17.57l-.24.33a6.43,6.43,0,0,1-.46.48L18,11.38,16.45,13l-1.8,1.8L9.81,19.62a1.43,1.43,0,0,1-.94.38,1.48,1.48,0,0,1-1.08-.34L.51,12.34A1.59,1.59,0,0,1,.53,10ZM16.59,4.82a1.39,1.39,0,0,0,1-.44,1.45,1.45,0,0,0,.43-1,1.46,1.46,0,1,0-2.92,0,1.44,1.44,0,0,0,.43,1,1.39,1.39,0,0,0,1,.44Zm0,0\" transform=\"translate(0 0)\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/common/menu-tag.svg
// module id = N8Tc
// module chunks = 264